import React from "react";
import line from "../../../../assets/img/admin/Union.svg";
import Button from "../../../shared/Button";
import IconBox from "../../../shared/IconBox";
const AdminFastsearchCon = ({searchlist}) => {
  return (
    <div className="AdminFastsearchCon mt-[32px]">
      <div className="flex justify-between items-center">
        <h2 className="">پیش نمایش</h2>
        <IconBox white smallxss>
          <img src={line} />
        </IconBox>
      </div>
      <div className="AdminFastsearchCon-container" >
     {searchlist.map(i=> <div className="tag">
        {i.title}
        </div>)}
       

      </div>
      <div className="flex justify-end items-center gap-[30px] ">
        <Button varient="gray">
        انصراف
        </Button>
        <Button varient="primary">
        ثبت تغیرات
        </Button>
      </div>
    </div>
  );
};

export default AdminFastsearchCon;
